import * as React from 'react';

import { TAdBannerPParams, TAdBannerPlaceParameters, TAdBannerSizes } from '../../../types/adBannerMicrofrontend';

/**
 * Значения размещения должны совпадать с легаси-баннером AdfoxBannerParallaxBetweenOffers,
 * иначе адфокс отдаст другую кампанию.
 */
const PLACE = 'between_offers';
const P_PARAMS: TAdBannerPParams = { p1: 'dazao', p2: 'y' };
const SIZES: TAdBannerSizes = { width: '100%', height: 560 };

export function useParallaxBetweenOffersParameters(position: number): TAdBannerPlaceParameters {
  return React.useMemo(
    (): TAdBannerPlaceParameters => ({
      carousel: null,
      deviceType: 'desktop',
      galleryPosition: null,
      isSp: false,
      pParams: P_PARAMS,
      place: PLACE,
      position,
      sizes: SIZES,
      tgbNativedescGeneralDesign: null,
    }),
    [position],
  );
}
